<template>
    <div>
        <!-- 钻石消费概览模块 -->
        <div class="data-panel" id="consume_coin" style="margin-bottom:0px;">
            <div class="data-panel-header">
                <h2>钻石花费概览</h2>
                <div class="extra">
                    <a-range-picker class="date_range_picker" v-model="coin.date_range" :allowClear="false"/>
                </div>
            </div>
        </div>
        <!-- 消耗趋势图 -->
        <div class="data-panel" style="margin:0;">
            <div class="data-panel-header" style="border-bottom:0; padding:10px 0 0 0;">
                <h2>{{coin.chart.filters.length==0?'总计':coin.chart.filters.length==1?`${coin.chart.filters[0]}(消费途径)`:coin.chart.filters.length==2?`${coin.chart.filters[1]}(道具大类)`:`${coin.chart.filters[2]}(道具)`}}-消耗趋势图</h2>
                <div class="extra">
                    <a-cascader :options="coin.types" placeholder="总计" changeOnSelect v-model="coin.chart.filters" :showSearch="{filter}" style="width:300px"/>
                    <a-radio-group v-model="coin.chart.coin_type" style="margin:0 0 0 16px;">
                        <a-radio-button value="coin_cnt">所有钻石</a-radio-button>
                        <a-radio-button value="pay_coin_cnt">付费钻石</a-radio-button>
                        <a-radio-button value="free_coin_cnt">免费钻石</a-radio-button>
                    </a-radio-group>
                </div>
            </div>
            <div class="data-panel-content fixed-data-panel-content">
                <a-spin :spinning="loading" tip="数据加载中..." class="loading" >
                    <Chart :datas="chart_datas" :conf="coin.chart.conf" :height="350" :fields="coin.chart.fields"/>
                </a-spin>
            </div>
        </div>
        <!-- 总体消耗情况 -->
        <div class="data-panel" style="margin:0">
            <div class="data-panel-header" style="border-bottom:0; border-top:1px dashed #ddd; padding:10px 0 0 0;">
                <h2>总体消耗情况</h2>
                <div class="extra">
                    <a-button @click="exportToExcel(`${coin.general_type}_table`, `总体消耗情况-${coin.general_type=='type'?'按道具大类':'按消费途径'}`)" :title="$t('common.downloadData')"><a-icon type="download"/></a-button>
                    <a-button @click="copy(`${coin.general_type}_table`)" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copyData')"><a-icon type="copy"/></a-button>
                    <a-radio-group v-model="coin.general_type">
                        <a-radio-button value="type">按道具大类</a-radio-button>
                        <a-radio-button value="src">按购买途径</a-radio-button>
                    </a-radio-group>
                </div>
            </div>
            <div class="data-panel-content fixed-data-panel-content">
                <a-spin :spinning="loading" tip="数据加载中..." class="loading" >
                    <DataTable :fields="coin.type.fields" :datas="group_datas.type" ref="type_table" @changeFilter="changeFilter" v-show="coin.general_type=='type'" :init="init"/>
                    <DataTable :fields="coin.src.fields" :datas="group_datas.src" ref="src_table" @changeFilter="changeFilter" v-show="coin.general_type=='src'" :init="init"/>
                </a-spin>
            </div>
        </div>
        <!-- 详细消耗情况 -->
        <div class="data-panel" style="margin:0;">
            <div class="data-panel-header" style="border-bottom:0; border-top:1px dashed #ddd; padding:10px 0 0 0;">
                <h2>详细消耗情况</h2>
                <div class="extra">
                    <a-button @click="exportToExcel('item_table', '详细消耗情况')" :title="$t('common.downloadData')"><a-icon type="download"/></a-button>
                    <a-button @click="copy('item_table')" id="copy-btn" style="margin:0 0 0 8px;" :title="$t('common.copyData')"><a-icon type="copy"/></a-button>
                </div>
            </div>
            <div class="data-panel-content fixed-data-panel-content">
                <a-spin :spinning="loading" tip="数据加载中..." class="loading" >
                    <DataTable :fields="coin.item.fields" :datas="group_datas.item" ref="item_table" @changeFilter="changeFilter" :init="init"/>
                </a-spin>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"
import Chart from '@/components/common/chart/chart.vue'
import DataTable from '@/components/common/uno_consume_datatable.vue'
import Mark from '@/components/common/chart/mark.vue'
import {weekday} from '@/utils/utils'
import {Cascader} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Cascader)
export default {
    props: ['submodules', 'marks'],
    components: {
        Chart,
        DataTable,
        Mark,
    },
    mounted() {
        this.initDate()
    },
    data() {
        return {
            loading: true,
            init: false,
            coin: {
                date_range:[],
                datas: {
                    this:[],
                    last:[],
                },
                group_datas: {
                    type: [],
                    src: [],
                    item: [],
                },
                types: [],
                chart: {
                    coin_type: 'coin_cnt',
                    filters: [],
                    conf: {
                        fixed: true,
                        versionday: 'dt',
                        type: 'line',
                        shape: 'splitLine',
                        x: {id: 'ds', title: '日期'},
                        y: {id: 'coin_cnt', title: '花费钻石数'},
                        color: ['#FFAE28',  '#1890FF', '#2FC25B', '#223273', '#8543E0', '#13C2C2', '#3436C7', '#F04864'],
                        series: {id:'series',},
                        slider: true,
                        mark: true,
                        other: {
                            legend: {
                                reversed: true,
                            }
                        }
                    },
                },
                // 总体消耗情况选择
                general_type: 'type',
                type: {
                    fields: [
                        {id: 'item_type', title:"道具大类", width:'16%', sorter:true}, 
                        {id: 'coin_cnt', title:'花费所有钻石', width:'15%', sorter:true},
                        {id: 'pay_coin_cnt', title:'花费付费钻石', width:'15%', sorter:true},
                        {id: 'free_coin_cnt', title:'花费免费钻石', width:'15%', sorter:true},
                        {id: 'cnt', title:'购买人次', width:'15%', sorter:true},
                        {id: 'coin_ratio', title:'花费占比', width:'12%', sorter:true, suffix:'%'},
                        {id: 'coin_compare', title:'环比变化', width:'12%', sorter:'compare_val'},
                    ],
                },
                src: {
                    fields: [
                        {id: 'src', title:"消费途径", width:'16%', sorter:true}, 
                        {id: 'coin_cnt', title:'花费所有钻石', width:'15%', sorter:true},
                        {id: 'pay_coin_cnt', title:'花费付费钻石', width:'15%', sorter:true},
                        {id: 'free_coin_cnt', title:'花费免费钻石', width:'15%', sorter:true},
                        {id: 'cnt', title:'购买人次', width:'15%', sorter:true},
                        {id: 'coin_ratio', title:'花费占比', width:'12%', sorter:true, suffix:'%'},
                        {id: 'coin_compare', title:'环比变化', width:'12%', sorter:'compare_val'},
                    ],
                },
                item: {
                    fields: [
                        {id: 'item_name', title:"道具名称", width:'15%',}, 
                        {id: 'item_type', title:"道具大类", width:'15%', sorter:true}, 
                        {id: 'src', title:"购买途径", width:'10%', sorter:true}, 
                        {id: 'item_cnt', title:'购买道具数', width:'12%', sorter:true},
                        {id: 'coin_cnt', title:'花费所有钻石', width:'12%', sorter:true},
                        {id: 'pay_coin_cnt', title:'花费付费钻石', width:'12%', sorter:true},
                        {id: 'free_coin_cnt', title:'花费免费钻石', width:'12%', sorter:true},
                        {id: 'coin_ratio', title:'花费占比', suffix:'%', width:'12%', sorter:true},
                    ],
                }
            }

        }
    },
    watch: {
        // 选择时间
        'coin.date_range'(newV) {
            if(newV && newV.length>=2) {
                this.getCoin()
            }
        },
        // 钻石类别
        'coin.chart.coin_type'(newV) {
            if(newV) {
                this.coin.chart.conf.y.id=newV
            }
        }
    },
    computed: {
        chart_datas() {
            let this_datas = this.coin.datas.this
            let last_datas = this.coin.datas.last
            if(this.coin.chart.filters.length == 0) {
                this_datas = this.calChartData(this.coin.datas.this, {})
                last_datas = this.calChartData(this.coin.datas.last, {})
            }
            else if(this.coin.chart.filters.length == 1) {
                this_datas = this.calChartData(this.coin.datas.this, {'src':this.coin.chart.filters[0]})
                last_datas = this.calChartData(this.coin.datas.last, {'src':this.coin.chart.filters[0]})
            }
            else if (this.coin.chart.filters.length == 2) {
                this_datas = this.calChartData(this.coin.datas.this, {'src':this.coin.chart.filters[0], 'item_type':this.coin.chart.filters[1]})
                last_datas = this.calChartData(this.coin.datas.last, {'src':this.coin.chart.filters[0], 'item_type':this.coin.chart.filters[1]})
            }
            else if (this.coin.chart.filters.length == 3) {
                this_datas = this.calChartData(this.coin.datas.this, {'src':this.coin.chart.filters[0], 'item_type':this.coin.chart.filters[1], 'item_name':this.coin.chart.filters[2]})
                last_datas = this.calChartData(this.coin.datas.last, {'src':this.coin.chart.filters[0], 'item_type':this.coin.chart.filters[1], 'item_name':this.coin.chart.filters[2]})
            }
            this_datas = _.orderBy(this_datas, ['ds', 'dt'], ['asc', 'asc'])
            last_datas = _.orderBy(last_datas, ['ds', 'dt'], ['asc', 'asc'])
            this_datas.forEach((row, r_index) => {
                ['coin_cnt', 'free_coin_cnt', 'pay_coin_cnt'].forEach((e) => {
                    row[`${e}_updown`] = r_index > 0 ? (this_datas[r_index-1][e] === 0 || this_datas[r_index-1][e] == null) ? '-' : Math.floor(((row[e] - this_datas[r_index-1][e]) / this_datas[r_index-1][e]) * 10000) / 100 : '-'
                })
            })
            last_datas.forEach((row, r_index) => {
                ['coin_cnt', 'free_coin_cnt', 'pay_coin_cnt'].forEach((e) => {
                    row[`${e}_updown`] = r_index > 0 ? (last_datas[r_index-1][e] === 0 || last_datas[r_index-1][e] == null) ? '-' : Math.floor(((row[e] - last_datas[r_index-1][e]) / last_datas[r_index-1][e]) * 10000) / 100 : '-'
                })
            })
            return  _.orderBy(last_datas.concat(this_datas), ['ds', 'dt'], ['asc', 'asc'])
        },
        group_datas() {
            let group_datas = _.cloneDeep(this.coin.group_datas)
            if(this.coin.chart.filters.length==0) {
                let d1 = _.find(group_datas.src, {src:'总计'})
                if(d1)
                    d1.selected = true
                let d2 = _.find(group_datas.type, {item_type:'总计'})
                if(d2)
                    d2.selected = true
            }
            if(this.coin.chart.filters.length==1) {
                let d = _.find(group_datas.src, {src:this.coin.chart.filters[0]})
                if(d)
                    d.selected = true
            }
            else if(this.coin.chart.filters.length==2) {
                let d = _.find(group_datas.type, {item_type:this.coin.chart.filters[1]})
                if(d)
                    d.selected = true
            }
            else if(this.coin.chart.filters.length==3) {
                let d = _.find(group_datas.item, {src:this.coin.chart.filters[0], item_type:this.coin.chart.filters[1], item_name:this.coin.chart.filters[2]})
                if(d)
                    d.selected = true
            }
            return group_datas
        },
        // marks() {
        //     let m = this.$store.getters.getModule(this.$route.meta.id)
        //     if(m && m.sub) {
        //         let marks = {}
        //         m.sub.forEach((s)=>{
        //             marks[s.ctrl] = this.$store.getters.getMarks(parseInt(s.id))
        //         })
        //         return marks
        //     }
        //     return []
        // },
        mark_permission() {
            return this.$store.state.game.info.mark
        },
    },
    methods: {
        initDate() {
            let today = moment()
            let month_ago = moment(today).subtract(27, 'day');
            this.coin.date_range = [month_ago, today]
        },
        getCoin() {
            this.loading = true
            let start_dt = this.coin.date_range[0]
            let end_dt = this.coin.date_range[1]
            
            let days = end_dt.diff(start_dt, 'day')
            let end_dt2 = moment(start_dt).subtract(1, 'day')
            let start_dt2 = moment(end_dt2).subtract(days, 'day')
            
            let q1 = this.$service.query_fixed_module('consume_coin', {start_dt:start_dt.format('YYYY-MM-DD'), end_dt:end_dt.format('YYYY-MM-DD')})
            let q2 = this.$service.query_fixed_module('consume_coin', {start_dt:start_dt2.format('YYYY-MM-DD'), end_dt:end_dt2.format('YYYY-MM-DD')})

            Promise.all([q1, q2]).then((datas) => {
                let types = {}
                for(let index=0; index<=1; index++) {
                    let dts = {}
                    let series = '本期', num = 2
                    if(index==1) {
                        series = `环比（${start_dt2.format('YYYY-MM-DD')}~${end_dt2.format('YYYY-MM-DD')}）`
                        num = 1
                    }
                    datas[index].forEach((row, r_index)=>{
                        // 初始化日期信息
                        if(!(row.day in dts)) {
                            let day = moment(start_dt).add(row.day, 'days')
                            dts[row.day] = {'ds': day.format('YYYY-MM-DD'), 'weekday':weekday[day.weekday()], 'dt_weekday': weekday[moment(row['dt']).weekday()]}
                        }
                        row['series'] = series
                        row['ds'] = dts[row.day]['ds']
                        row['weekday'] = dts[row.day]['weekday']
                        row['dt_weekday'] = dts[row.day]['dt_weekday']
                        row['num'] = num
                        // 取出物品分类
                        if(!(row.src in types)) {
                            types[row.src] = {}
                        }
                        if(!(row.item_type in types[row.src])) {
                            types[row.src][row.item_type] = []
                        }
                        if(types[row.src][row.item_type].indexOf(row.item_name)<0) {
                            types[row.src][row.item_type].push(row.item_name)
                        }
                    })
                }
                
                // 初始化筛选条件
                this.coin.types = this.initFilter(types)
                // 计算各表格数据
                this.coin.group_datas = this.calGroupDataCompare(this.calGroupData(datas[0]), this.calGroupData(datas[1]))
                this.init = true
                this.$nextTick(()=>{
                    this.init = false
                })
                // 保存两期数据
                this.coin.datas = {
                    this: datas[0],
                    last: datas[1],
                }
                this.loading = false

            }).catch((errors)=>{
                this.loading = false
            })
        },
        // 初始化筛选条件
        initFilter(types) {
            let type_filters = []
            Object.keys(types).forEach((src)=>{
                let src_filter = {value:src, label:src, children:[]}
                Object.keys(types[src]).forEach((type)=>{
                    let type_filter = {value:type, label:type, children:[]}
                    types[src][type].forEach((child)=>{
                        type_filter.children.push({value:child, label:child})
                    })
                    src_filter.children.push(type_filter)
                })
                type_filters.push(src_filter)
            })
            this.coin.chart.filters = []
            return type_filters
        },
        // 过滤
        calChartData(datas, filters) {
            let keys = ['cnt', 'item_cnt', 'coin_cnt', 'free_coin_cnt', 'pay_coin_cnt']
            let dts = {}
            // 根据日期聚合
            datas.forEach((row)=>{
                let flag = true
                Object.keys(filters).forEach((filter_key)=>{
                    if(row[filter_key] != filters[filter_key]) {
                        flag = false
                    }
                })
                if(flag) {
                    if(!(row.dt in dts)) {
                        dts[row.dt] = keys.reduce((result, key)=>{result[key]=0; return result}, {dt:row.dt, ds:row.ds, weekday:row.weekday, dt_weekday:row.dt_weekday, series:row.series, num:row.num})
                    }
                    keys.forEach((key)=>{
                        dts[row.dt][key]+=row[key]
                    })
                }
            })
            return Object.values(dts)
        },
        // 将所有数据分类
        calGroupData(datas) {
            let keys = ['cnt', 'item_cnt', 'coin_cnt', 'free_coin_cnt', 'pay_coin_cnt']
            // 总计
            let total = keys.reduce((result, key)=>{result[key]=0; return result}, {'datatable_summary_td':true, 'item_type':'总计', 'src':'总计'})
            
            // 按类别、途径、道具分类
            let types = {}, srcs = {}, items = {}
            datas.forEach((row)=>{
                let item_key = `${row.item_type}-${row.item_name}-${row.src}`
                if(!(row.item_type in types)) {
                    types[row.item_type] = keys.reduce((result, key)=>{result[key]=0; return result}, {item_type:row.item_type})
                }
                if(!(row.src in srcs)) {
                    srcs[row.src] = keys.reduce((result, key)=>{result[key]=0; return result}, {src:row.src})
                }
                if(!(item_key in items)) {
                    items[item_key] = keys.reduce((result, key)=>{result[key]=0; return result}, {item_type:row.item_type, item_name:row.item_name, src:row.src})
                }
                keys.forEach((key)=>{
                    total[key] += row[key]
                    types[row.item_type][key]+=row[key]
                    srcs[row.src][key]+=row[key]
                    items[item_key][key]+=row[key]
                })
            })
            
            // 计算花费占比
            Object.keys(types).forEach((key)=>{
                types[key]['coin_ratio'] = Number((types[key]['coin_cnt']/total['coin_cnt']*100).toFixed(2))
            })
            Object.keys(srcs).forEach((key)=>{
                srcs[key]['coin_ratio'] = Number((srcs[key]['coin_cnt']/total['coin_cnt']*100).toFixed(2))
            })
            Object.keys(items).forEach((key)=>{
                items[key]['coin_ratio'] = Number((items[key]['coin_cnt']/total['coin_cnt']*100).toFixed(2))
            })

            // 增加总计行
            types['总计'] = total
            srcs['总计'] = total

            return {
                type: types,
                src: srcs,
                item: items,
            }
        },
        // 计算环比
        calGroupDataCompare(this_datas, last_datas) {
            let down_icon = '<i class="anticon anticon-caret-down" style="color: rgb(144, 216, 108);"><svg viewBox="0 0 1024 1024" data-icon="caret-down" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z"></path></svg></i>'
            let up_icon = '<i class="anticon anticon-caret-up" style="color: rgb(245, 34, 45);"><svg viewBox="0 0 1024 1024" data-icon="caret-up" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class=""><path d="M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z"></path></svg></i>'
            let compareKey = 'coin_cnt', compareValueKey= 'compare_val', compareResultKey= 'coin_compare'
            function compareRow(datatype, datakey) {
                let t_data = this_datas[datatype][datakey]
                let l_data = last_datas[datatype][datakey]
                let compare = null
                if(l_data) {
                    if(l_data[compareKey]) {
                        compare = (t_data[compareKey] - l_data[compareKey]) *100.0 / l_data[compareKey]
                    }
                }
                t_data[compareValueKey] = compare
                t_data[compareResultKey] = ''
                if(compare > 0) {
                    t_data[compareResultKey] += `${up_icon}<span style="display:inline-block; width:60px;">${compare.toFixed(2)}%</span>`
                }
                else if(compare < 0) {
                    t_data[compareResultKey] += `${down_icon}<span style="display:inline-block; width:60px;">${-compare.toFixed(2)}%</span>`
                }
                else {
                    t_data[compareResultKey] += `<span style="display:inline-block; width:60px;">-</span> `
                }
            }

            Object.keys(this_datas.type).forEach((type)=>{
                if(type!='总计') {
                    compareRow('type', type)
                }
            })

            Object.keys(this_datas.src).forEach((src)=>{
                if(src!='总计') {
                    compareRow('src', src)
                }
            })
            
            return {
                type: _.orderBy(Object.values(this_datas.type), ['coin_cnt', 'pay_coin_cnt', 'cnt', 'item_cnt'], ['desc', 'desc', 'desc', 'desc']),
                src: _.orderBy(Object.values(this_datas.src), ['coin_cnt', 'pay_coin_cnt', 'cnt', 'item_cnt'], ['desc', 'desc', 'desc', 'desc']),
                item: _.orderBy(Object.values(this_datas.item), ['coin_cnt', 'pay_coin_cnt', 'item_cnt', 'cnt'], ['desc', 'desc', 'desc', 'desc']),
            }
        },
        changeFilter(filter) {
            if(filter.length==3) {
                if(filter[0] == '总计') {
                    this.coin.chart.filters = []
                }
                else if(filter[2]) {
                    this.coin.chart.filters = filter
                }
                else if(filter[1]) {
                    let filter_src = null
                    this.coin.types.forEach((src)=>{
                        let tmp_src = _.find(src.children, {value:filter[1]})
                        if(tmp_src) {
                            filter_src = src.value
                        }
                    })
                    this.coin.chart.filters = [filter_src?filter_src:filter[0], filter[1]]
                }
                else {
                    this.coin.chart.filters = [filter[0]]
                }
            }
        },
        filter(inputValue, path) {
            return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1,);
        },
        //下载
        exportToExcel(table, filename) {
            this.$refs[table].exportToExcel(filename)
        },
        //复制
        copy(table) {
            this.$refs[table].copy()
        },
    },
}
</script>